/** ----------------------------------------
    Menu Fade In
 ---------------------------------------- */

export let fadeIn = {
    opacity: 1,
    duration: 450,
    easing: 'easeOutQuad'
};

/** ----------------------------------------
    Menu Fade Out
 ---------------------------------------- */

export let fadeOut = {
    opacity: 0,
    duration: 450,
    easing: 'easeOutQuad'
};